import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/courseEnrollment/importer/courseEnrollmentImporterActions'

export default importerReducers(actions)
